import { DashboardData, DashboardMetrics } from './dashboardTypes';

export function calculateMetrics(data: DashboardData): DashboardMetrics {
  const {
    roles = [],
    candidates = [],
    jobMatches = [],
    candidateMatches = [],
    jobTopics = [],
    candidateTopics = [],
  } = data;

  // Combine and deduplicate matches
  const matchIds = new Set<string>();
  const allMatches = [...jobMatches, ...candidateMatches].filter((match) => {
    if (matchIds.has(match.id)) {
      return false;
    }
    matchIds.add(match.id);
    return true;
  });

  // Calculate role metrics
  const totalRoles = roles.length;
  const openRoles = roles.filter(
    (r) => r.status === 'SHARED' || r.status === 'PLATFORM_INCLUDED'
  ).length;
  const privateRoles = roles.filter((r) => r.audience === 'PRIVATE').length;
  const publicSharedRoles = roles.filter(
    (r) => r.audience !== 'PRIVATE' && r.status === 'SHARED'
  ).length;

  // Calculate candidate metrics
  const totalCandidates = candidates.length;

  // Calculate match metrics
  const totalMatches = allMatches.length;
  const activeMatches = allMatches.filter((m) =>
    ['NEW', 'ACCEPTED', 'INTERVIEWING'].includes(m.currentStatus)
  ).length;
  const newMatches = allMatches.filter((m) => m.currentStatus === 'NEW').length;

  // Calculate unread messages
  const unreadMessages = [...jobTopics, ...candidateTopics].filter(
    (t) => t.isResolvedByOwner === false
  ).length;

  // Calculate recent items (last 7 days)
  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;

  const recentRoles = roles
    .filter((r) => new Date(r.createdAt).getTime() > sevenDaysAgo)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5);

  const recentCandidates = candidates
    .filter((c) => new Date(c.createdAt || c.updatedAt).getTime() > sevenDaysAgo)
    .sort(
      (a, b) =>
        new Date(b.createdAt || b.updatedAt).getTime() -
        new Date(a.createdAt || a.updatedAt).getTime()
    )
    .slice(0, 5);

  const recentMatches = allMatches
    .filter((m) => new Date(m.createdAt).getTime() > sevenDaysAgo)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, 5);

  return {
    totalRoles,
    openRoles,
    privateRoles,
    publicSharedRoles,
    totalCandidates,
    totalMatches,
    activeMatches,
    newMatches,
    unreadMessages,
    recentRoles,
    recentCandidates,
    recentMatches,
  };
}
